<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <ProjectForm :baseProject="project" :baseprojectName="name" :loading="loading" @submit-requested="submitRequested"></ProjectForm>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import ProjectForm from '@/views/Projects/ProjectForm.vue'
    import router from '@/router';

    export default {
        data() {
            return {
                project: null,
                name: this.$route.params.name,
                loading: true
            }
        },
        components: { ProjectForm },
        computed:
        {
            ...mapState('projects', ['getProjectByIdOutput']),
        },
        methods: {
            ...mapActions('projects', ['getProjectById']),
            ...mapActions('projects', ['putProject']),
            submitRequested(project) {
                this.putProject(project);
            },
        },
        mounted: function () {
            if (!this.$route.query.id) {
                router.push({ path: '/projects/list' });
            }
            else {
                this.getProjectById(this.$route.query.id);
            }
        },
        watch:
        {
            getProjectByIdOutput: function (output) {
                if (!output && !output.data) {
                    router.push({ name: 'ProjectsList' });
                }
                else {
                    this.project = output.data;
                    this.loading = false;
                }
            }
        }
    }
</script>